



































































































































































































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { IFilter, ISorter } from "@/models/tables";
import { DataModules } from "@/store/modules/data";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import AdminBrandId from "@/mixins/adminBrandId";
import { FilterOperators, FilterTypes } from "@/data/table";
import { IDomain } from "@/models/domains";

@Component
export default class DomainsTable extends mixins(
  FilteringSortingTableStore,
  AdminBrandId
) {
  public filters: IFilter[] = [
    {
      key: "origin",
      label: this.$t("_.domain"),
      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL
    },
    {
      key: "created_at",
      label: this.$t("_.date_added"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "origin",
      label: this.$t("_.domain")
    },
    {
      field: "created_at",
      label: this.$t("_.date_added")
    }
  ];

  public loading = true;
  public dataModule: DataModules = DataModules.OAUTH_CLIENTS;

  public created() {
    if (!this.$userCan("list_oauth_clients")) {
      this.loading = false;
      return;
    }
    this.getData();
  }

  public async deleteDomain(domainId: IDomain["id"]) {
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t("_sentence.delete_confirmation", {
            object: (this.$t("_.domain") as string).toLowerCase()
          })
        },
        events: {
          confirmed: async () => {
            await this.onDeleteConfirmed(domainId);
            confirm.close();
          }
        }
      }
    });
  }

  public async onDeleteConfirmed(domainId: IDomain["id"]) {
    try {
      this.table.loading = true;
      await this.$store.dispatch(`data/${DataModules.OAUTH_CLIENTS}/remove`, {
        id: domainId,
        vm: this
      });
      this.getData({ ignoreStored: true });
      this.$buefy.toast.open({
        message: this.$t("_.custom_domain_removed") as string
      });
    } catch (error) {
      this.handleUpdateError(error);
    }
  }

  public verifyDomain(domainId: IDomain["id"]) {
    this.table.loading = true;
    return this.$store
      .dispatch(`data/${DataModules.OAUTH_CLIENTS}/verify`, {
        id: domainId,
        vm: this
      })
      .then(this.handleUpdateSuccess)
      .catch(this.handleUpdateError);
  }

  public originHealth(domainId: IDomain["id"]) {
    this.table.loading = true;
    return this.$store
      .dispatch(`data/${DataModules.OAUTH_CLIENTS}/originHealth`, {
        id: domainId,
        vm: this
      })
      .then(this.handleUpdateSuccess)
      .catch(this.handleUpdateError);
  }

  public handleUpdateSuccess(removed = false) {
    this.getData({ ignoreStored: true });

    this.$buefy.toast.open({
      message: this.$t(
        `_.object_successfully_${!removed ? "removed" : "updated"}`,
        {
          object: this.$t("_.domain") as string
        }
      ) as string
    });
  }

  public handleUpdateError(error) {
    this.$store.dispatch("api/handleValidationError", {
      error,
      vm: this
    });
    this.table.loading = false;
  }

  public update(domainId: IDomain["id"], data: any) {
    this.table.loading = true;
    return this.$store
      .dispatch(`data/${DataModules.OAUTH_CLIENTS}/update`, {
        id: domainId,
        vm: this,
        data
      })
      .then(this.handleUpdateSuccess)
      .catch(this.handleUpdateError);
  }

  public async openUpdateModal(domainId) {
    if (!this.$userCan("update_oauth_client")) return;
    await this.$store.dispatch("data/oauthClients/openManageDomainModal", {
      props: {
        domainId
      },
      events: {
        "domain-saved": () => this.getData({ ignoreStored: true })
      }
    });
  }

  public shouldShowDropDown(domain) {
    return (
      this.$userCan("get_oauth_client") ||
      (this.$userCan("verify_oauth_client") && !domain.verified) ||
      (domain.verified && !domain.default && domain.origin_healthy) ||
      (this.$userCan("check_oauth_client_origin_health") &&
        domain.verified &&
        !domain.origin_healthy) ||
      (!domain.default && !domain.revoked) ||
      (!domain.default && domain.revoked) ||
      (this.$userCan("delete_oauth_client") && domain.custom && !domain.default)
    );
  }
}
